export const CouncilMeetingAgendaTemplate = {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
        level: 1,
      },
      content: [
        {
          type: 'text',
          text: 'Approval of Agenda',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
          ],
          text: 'Write down who is approving the agenda and the link to previous meeting minutes',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
    },
    {
      type: 'heading',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Opening remarks \u0026 update from Chairman',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
          ],
          text: 'The chairman of the meeting presents any initial updates before jumping into the meeting',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Talking points',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Review \u0026 approval of last meeting tasks ',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Open issues',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'New Meeting Agenda',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'New talking points',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Performance update',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Project updates',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Committee updates',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Other updates',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Financials',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
        level: 3,
      },
    },
    {
      type: 'heading',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Summary of Action Items \u0026 Tasks',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
          ],
          text: 'Assign tasks and deadlines here',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
        level: 3,
      },
    },
    {
      type: 'heading',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Closing',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Date and time of the next council meeting',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Following-up on action items assigned \u0026 questions',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Secretary approval',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Chairperson approval',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
    },
    {
      type: 'heading',
      attrs: {
        nodeIndent: 0,
        nodeTextAlignment: '',
        nodeLineHeight: null,
        style: '',
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Meeting Notes',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
    },
  ],
};
